import React, { createContext, useContext, useState } from "react";
import { CircularProgress } from "@mui/material";
import { Modal as BootstrapModal } from "react-bootstrap";
import "./Loder.css";

function Loder({ show, setShow }) {
  return (
    <div className="modal">
      <BootstrapModal
        className="modalLoader"
        show={show}
        onHide={() => setShow(false)}
        // size={size}
        // fullscreen="sm-down"
        backdrop="static"
        centered
      >
        <BootstrapModal.Body style={{ margin: "auto", border: "none" }}>
          <CircularProgress color="success" />
        </BootstrapModal.Body>
      </BootstrapModal>
    </div>
  );
}

// Create a context for the loader
const LoaderContext = createContext();

// Custom hook to use the loader context
// export const useLoader = () => useContext(LoaderContext);

// LoaderProvider component to wrap your app and manage loader state
export function LoaderProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);

  // Function to open the loader
  const openLoader = () => {
    // setTimeout(() => {
    setIsLoading(true);
    // }, 2000);
  };

  // Function to close the loader
  const closeLoader = () => {
    // setTimeout(() => {
    setIsLoading(false);
    // }, 2000);

    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 2000);
  };

  // Function to toggle the loader
  const toggleLoader = () => {
    setIsLoading((prevState) => !prevState);
  };

  return (
    <LoaderContext.Provider
      value={{ isLoading, openLoader, closeLoader, toggleLoader }}
    >
      {children}
      <Loder show={isLoading} setShow={setIsLoading} />
    </LoaderContext.Provider>
  );
}
export function useLoader() {
  return useContext(LoaderContext);
}
